import AdminLoadable from 'components/core/AdminLoadable';

const Videos = AdminLoadable({
  loader: () => import('./AnalyticsConnected'),
  name: 'Videos',
});

export { Videos as default };
